import Image from "next/image";
import { Typography } from "@/components/ui";
import { useDesigner, UseDesignerProps } from "./use-designer";

export type DesignerProps = UseDesignerProps;

export const Designer = (props: DesignerProps) => {
  const { styles, className, data } = useDesigner(props);
  const { name, image } = data;

  return (
    <div className={styles.base({ className })}>
      <Typography
        as="h3"
        fontSize="heading-sm"
        fontFamily="chillen"
        spacing="wide"
        uppercase
        className={styles.name()}
      >
        {name}
      </Typography>
      <Image
        fill
        alt={name}
        src={image}
        quality="100"
        sizes="100vw"
        className={styles.image()}
      />
    </div>
  );
};
